export default __webpack_public_path__ + "static/media/paging_next_B_active.63c95cf9.svg";